import React from 'react';
import { styled } from "@mui/material/styles";
import { Box } from '@mui/system';
import { Chip, Grid, IconButton, Typography } from '@mui/material';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import { useParams } from 'react-router-dom';



const useStyles = styled((theme) => ({
    root: {
        flexGrow: 1,
        bgcolor: '#E5E5E5',
        fontFamily: 'Montserrat'
    }

}));

const ScholarshipDetails = () => {
    const classes = useStyles();
    let { id } = useParams();
    console.log(id);
    return (
        <Box className={classes.root} sx={{ bgcolor: '#fafafa', }}>
            <Box sx={{
                // marginLeft: 2,
                // marginRight: 2,
                borderRadius: 2,
                position: 'relative',
            }}>
                <Box sx={{ height: '230px', backgroundImage: `url(${process.env.PUBLIC_URL}/img/college_details.png)` }}></Box>
                <Box sx={{ backgroundColor: '#fff', paddingTop: '38px', borderRadius: '10px', width: '100%' }}>
                    <Grid container>
                        <Grid item xs={2} style={{textAlign:"center",paddingTop:"10px"}}><img alt='' src={`${process.env.PUBLIC_URL}/img/college-img.png`} /></Grid>
                        <Grid item xs={10} sx={{ pl: 1, position: 'relative' }}>
                            <Typography sx={{ fontWeight: 'bold', fontSize: '15px', mt: 1 }}>The Collage of saint Rose</Typography>
                            <Typography sx={{ fontSize: '13px' }}>Computer Information System</Typography>
                            <hr style={{ maxWidth: '70%', marginRight: '30%', color: '#fff' }} />

                            <Typography sx={{ mt: 1, fontSize: '15px' }}>May (01-01-1970)  <span style={{ float: 'right', marginRight: '10px', fontWeight: 'bold', fontSize: '16px' }}>$25000</span></Typography>

                            <img alt='' src={`${process.env.PUBLIC_URL}/img/percenatge.png`} style={{ marginTop: '15px' }} />
                            <Chip label="Apply" sx={{ bgcolor: '#1B6CFC', color: '#fff', position: 'absolute', marginTop: '5px', right: 0, marginRight: '25px', }} />

                            <Box sx={{ position: 'absolute', top: 0, right: 10 }}>
                                <IconButton
                                    size="small"
                                    edge="end"
                                    aria-label="account of current user"
                                    // aria-controls={menuId}
                                    aria-haspopup="true"
                                    color="inherit"
                                >
                                    <ShareOutlinedIcon />
                                </IconButton>
                            </Box>
                        </Grid>
                    </Grid>

                    <Grid container sx={{
                        px:"5px",
                        marginTop: 2,
                    }} spacing={1}>
                        <Grid item xs={6}>
                            <Typography sx={{ fontSize: '12px', }}><img alt='' style={{ marginRight: 10 }} src={`${process.env.PUBLIC_URL}/img/product_detail/gpa.png`} height="14px" />Nationality : <span style={{ float: 'right', paddingRight: 20 }}>60</span></Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography sx={{ fontSize: '12px', }}><img alt='' style={{ marginRight: 10 }} src={`${process.env.PUBLIC_URL}/img/product_detail/university.png`} height="14px" />Funding : <span style={{ float: 'right', paddingRight: 20 }}>60</span></Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography sx={{ fontSize: '12px', }}><img alt='' style={{ marginRight: 10 }} src={`${process.env.PUBLIC_URL}/img/product_detail/semester.png`} height="14px" />Awarding Body  : <span style={{ float: 'right', paddingRight: 20 }}>60</span></Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography sx={{ fontSize: '12px', }}><img alt='' style={{ marginRight: 10 }} src={`${process.env.PUBLIC_URL}/img/product_detail/qs.png`} height="14px" />Collateral : <span style={{ float: 'right', paddingRight: 20 }}>60</span></Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography sx={{ fontSize: '12px', }}><img alt='' style={{ marginRight: 10 }} src={`${process.env.PUBLIC_URL}/img/product_detail/deadline.png`} height="14px" />Countries : <span style={{ float: 'right', paddingRight: 20 }}>60</span></Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography sx={{ fontSize: '12px', }}><img alt='' style={{ marginRight: 10 }} src={`${process.env.PUBLIC_URL}/img/product_detail/university.png`} height="14px" />Exam Required : <span style={{ float: 'right', paddingRight: 20 }}>60</span></Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography sx={{ fontSize: '12px', }}><img alt='' style={{ marginRight: 10 }} src={`${process.env.PUBLIC_URL}/img/product_detail/file.png`} height="14px" />App Start Date : <span style={{ float: 'right', paddingRight: 20 }}>60</span></Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography sx={{ fontSize: '12px', }}><img alt='' style={{ marginRight: 10 }} src={`${process.env.PUBLIC_URL}/img/product_detail/enroll.png`} height="14px" />No of Awards : <span style={{ float: 'right', paddingRight: 20 }}>60</span></Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography sx={{ fontSize: '12px', }}><img alt='' style={{ marginRight: 10 }} src={`${process.env.PUBLIC_URL}/img/product_detail/admit.png`} height="14px" />Interest Rate : <span style={{ float: 'right', paddingRight: 20 }}>60</span></Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography sx={{ fontSize: '12px', }}><img alt='' style={{ marginRight: 10 }} src={`${process.env.PUBLIC_URL}/img/product_detail/accept.png`} height="14px" />Success Rate : <span style={{ float: 'right', paddingRight: 20 }}>60</span></Typography>
                        </Grid>

                    </Grid>
                    <hr style={{ marginTop: '15px', marginRight: '5%', marginLeft: '5%', color: '#fff' }} />

                    <Box>
                        <Grid container sx={{
                            px:"5px",
                            marginTop: 2,
                            fontSize: '14px',
                        }} spacing={2}>
                            <Grid item >ILTES : <span style={{ color: '#1B6CFC', fontWeight: 'bold' }}>6</span></Grid>
                            <Grid item >PTE : <span style={{ color: '#1B6CFC', fontWeight: 'bold' }}>58</span></Grid>
                            <Grid item >TOEFL : <span style={{ color: '#1B6CFC', fontWeight: 'bold' }}>80</span></Grid>
                            <Grid item >WES : <span style={{ color: '#1B6CFC', fontWeight: 'bold' }}>80</span></Grid>
                            <Grid item >GRE :  <span style={{ color: '#FC5602', }}>Not Applicable</span></Grid>
                            <Grid item >GMAT : <span style={{ color: '#FC5602', }}>Not Applicable </span></Grid>
                        </Grid>
                    </Box>
                    <hr style={{ marginTop: '15px', marginRight: '5%', marginLeft: '5%', color: '#fff' }} />
                    <Box sx={{
                        px:"5px",
                        marginTop: '20px',
                    }}>
                        <Typography sx={{ color: '#1A1A1A', fontSize: '16px', fontWeight: 'bold' }}>
                            All Details
                            <span style={{ float: 'right', fontWeight: 'normal' }}>
                                See all
                            </span>
                        </Typography>

                        <Box sx={{ marginTop: '20px', bgcolor: '#1B6CFC', borderTopLeftRadius: '10px', borderTopRightRadius: '10px', paddingX: '10px', paddingY: '5px' }}>
                            <Typography sx={{ color: '#fff', fontWeight: 'bold', fontSize: '14px' }}>How To Apply</Typography>
                        </Box>
                        <Box sx={{ paddingX: '10px', paddingY: '5px' }}>
                            <Typography sx={{ paddingY: '5px', fontWeight: 'bold',fontSize:"13px" }}>Specialisation : <span style={{ fontWeight: 'normal', fontSize: '15px' }}></span></Typography>
                        </Box>

                        <Box sx={{ marginTop: '20px', bgcolor: '#1B6CFC', borderTopLeftRadius: '10px', borderTopRightRadius: '10px', paddingX: '10px', paddingY: '5px' }}>
                            <Typography sx={{ color: '#fff', fontWeight: 'bold', fontSize: '14px' }}>Entry Requirments</Typography>
                        </Box>
                        <Box sx={{ paddingX: '10px', paddingY: '5px' }}>
                            <Typography sx={{ paddingY: '5px', fontWeight: 'bold',fontSize:"13px" }}>Eligibility Requirement : <span style={{ fontWeight: 'normal', }}>Entry Requirments</span></Typography>
                        </Box>

                        <Box sx={{ marginTop: '20px', bgcolor: '#1B6CFC', borderTopLeftRadius: '10px', borderTopRightRadius: '10px', paddingX: '10px', paddingY: '5px' }}>
                            <Typography sx={{ color: '#fff', fontWeight: 'bold', fontSize: '14px' }}>Important Dates</Typography>
                        </Box>
                        <Box sx={{ paddingX: '10px', paddingY: '5px' }}>
                            <Typography sx={{ paddingY: '5px', fontWeight: 'bold',fontSize:"13px" }}>Semester : <span style={{ fontWeight: 'normal', fontSize: '15px' }}></span></Typography>
                            <Typography sx={{ paddingY: '5px', fontWeight: 'bold',fontSize:"13px" }}>Application End Date : <span style={{ fontWeight: 'normal', fontSize: '15px' }}></span></Typography>
                            <Typography sx={{ paddingY: '5px', fontWeight: 'bold',fontSize:"13px" }}>Application Start Date : <span style={{ fontWeight: 'normal', fontSize: '15px' }}> Deadlines may warry please check the links or university websites</span></Typography>
                        </Box>

                        {/* financial detaisl */}
                        <Box sx={{ marginTop: '20px', bgcolor: '#1B6CFC', borderTopLeftRadius: '10px', borderTopRightRadius: '10px', paddingX: '10px', paddingY: '5px' }}>
                            <Typography sx={{ color: '#fff', fontWeight: 'bold', fontSize: '14px' }}>Document Required</Typography>
                        </Box>
                        <Box sx={{ paddingX: '10px', paddingY: '5px' }}>
                            <Typography sx={{ paddingY: '5px', fontWeight: 'bold',fontSize:"13px" }}>Passport : <span style={{ fontWeight: 'normal' }}></span></Typography>
                            <Typography sx={{ paddingY: '5px', fontWeight: 'bold',fontSize:"13px" }}>10th Certificate : <span style={{ fontWeight: 'normal' }}></span></Typography>
                            <Typography sx={{ paddingY: '5px', fontWeight: 'bold',fontSize:"13px" }}>Course Completion Certificate : <span style={{ fontWeight: 'normal' }}></span></Typography>
                            <Typography sx={{ paddingY: '5px', fontWeight: 'bold',fontSize:"13px" }}>Provisional Degree Certificate : <span style={{ fontWeight: 'normal'}}></span></Typography>
                            <Typography sx={{ paddingY: '5px', fontWeight: 'bold',fontSize:"13px"}}>Degree certificate : <span style={{ fontWeight: 'normal'}}></span></Typography>
                            <Typography sx={{ paddingY: '5px', fontWeight: 'bold',fontSize:"13px" }}>Official Transcript : <span style={{ fontWeight: 'normal'}}></span></Typography>
                            <Typography sx={{ paddingY: '5px', fontWeight: 'bold',fontSize:"13px" }}>TOEFL : <span style={{ fontWeight: 'normal' }}></span></Typography>
                            <Typography sx={{ paddingY: '5px', fontWeight: 'bold',fontSize:"13px" }}>IELTS : <span style={{ fontWeight: 'normal'}}></span></Typography>
                            <Typography sx={{ paddingY: '5px', fontWeight: 'bold',fontSize:"13px" }}>GRE : <span style={{ fontWeight: 'normal' }}></span></Typography>
                            <Typography sx={{ paddingY: '5px', fontWeight: 'bold',fontSize:"13px" }}>GMAT : <span style={{ fontWeight: 'normal'}}></span></Typography>
                            <Typography sx={{ paddingY: '5px', fontWeight: 'bold',fontSize:"13px" }}>SAT : <span style={{ fontWeight: 'normal' }}></span></Typography>
                            <Typography sx={{ paddingY: '5px', fontWeight: 'bold',fontSize:"13px" }}>PTE : <span style={{ fontWeight: 'normal' }}></span></Typography>
                            <Typography sx={{ paddingY: '5px', fontWeight: 'bold',fontSize:"13px" }}>Affidavite of Support : <span style={{ fontWeight: 'normal' }}></span></Typography>
                        </Box>

                        {/* Scholarships  */}
                        <Box sx={{ marginTop: '20px', bgcolor: '#1B6CFC', borderTopLeftRadius: '10px', borderTopRightRadius: '10px', paddingX: '10px', paddingY: '5px' }}>
                            <Typography sx={{ color: '#fff', fontWeight: 'bold', fontSize: '14px' }}>Universities</Typography>
                        </Box>
                        <Box sx={{ paddingX: '10px', paddingY: '5px' }}>
                            <Typography sx={{ paddingY: '5px', fontWeight: 'bold',fontSize:"13px" }}>University name  : <span style={{ fontWeight: 'normal', fontSize: '15px' }}>Other</span></Typography>
                            <Typography sx={{ paddingY: '5px', fontWeight: 'bold',fontSize:"13px" }}>University name  : <span style={{ fontWeight: 'normal', fontSize: '15px' }}>Other</span></Typography>
                        </Box>

                        {/* Scholarships  */}
                        <Box sx={{ marginTop: '20px', bgcolor: '#1B6CFC', borderTopLeftRadius: '10px', borderTopRightRadius: '10px', paddingX: '10px', paddingY: '5px' }}>
                            <Typography sx={{ color: '#fff', fontWeight: 'bold', fontSize: '14px' }}>Other</Typography>
                        </Box>
                        <Box sx={{ paddingX: '10px', paddingY: '5px' }}>
                            <Typography sx={{ paddingY: '5px', fontWeight: 'bold',fontSize:"13px" }}>MBA | September : <span style={{ fontWeight: 'normal', fontSize: '15px' }}></span></Typography>
                        </Box>
                        <Box sx={{ paddingX: '10px', paddingY: '5px' }}>
                            <Typography sx={{ paddingY: '5px', fontWeight: 'bold',fontSize:"13px" }}>ACCELERATED MBA | September : <span style={{ fontWeight: 'normal', fontSize: '15px' }}></span></Typography>
                        </Box>
                    </Box>
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                </Box>
            </Box>
        </Box>
    )
}

export default ScholarshipDetails;
